import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=4bd440c5&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=ts&"
export * from "./Scan.vue?vue&type=script&lang=ts&"
import style0 from "./Scan.vue?vue&type=style&index=0&id=4bd440c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd440c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Code Repository/web-apps/packages/dimssa-field-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
